<template>
  <div class="row model-list">
    <model-card
      v-for="item in itemsFromSelectedGroup"
      :key="item.make.name + item.MODNameGrp1 + item.body_type + item.MODBegin"
      :model="item"
      :page="page"
    />
  </div>
</template>

<script>
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  const modelModule = namespace('model');
  const priceSearchModule = namespace('price_search');

  @Component
  export default class ModelList extends Vue {
    @modelModule.Getter('getItemsFromSelectedGroup') itemsFromSelectedGroup
    @priceSearchModule.Mutation('setFilters') setFilters;

    @Prop(String) page;

    created() {
      if (!(window.location.pathname).toString().includes("lista-berleti-dij-alapjan")) {
        localStorage.removeItem('filter');
        this.setFilters(null);
      }
    }

  }
</script>
